import { render, staticRenderFns } from "./SettingsPushNotificationsTable.vue?vue&type=template&id=6227ad5a&scoped=true&"
import script from "./SettingsPushNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./SettingsPushNotificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPushNotificationsTable.vue?vue&type=style&index=0&id=6227ad5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227ad5a",
  null
  
)

export default component.exports